import React from "react";
import SportsCricketIcon from "@material-ui/icons/SportsCricket";
import PolicyIcon from "@material-ui/icons/Policy";
import LockIcon from "@material-ui/icons/Lock";
import InfoIcon from "@material-ui/icons/Info";
import AssignmentIcon from "@material-ui/icons/Assignment";
import HelpIcon from "@material-ui/icons/Help";
import SettingsIcon from "@material-ui/icons/Settings";
import MailIcon from "@material-ui/icons/Mail";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import SearchIcon from "@material-ui/icons/Search";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import ExploreIcon from "@material-ui/icons/Explore";
import TuneIcon from "@material-ui/icons/Tune";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import HomeIcon from "@material-ui/icons/Home";
import { s3BaseURL } from "./constantInformation";
const Spordia = () => {
  return (
    <img
      className="text-primary mr-3"
      src={s3BaseURL + "res/spordia_logo_48.png"}
      style={{ objectFit: "contain", width: "23px", height: "100%" }}
    />
  );
};

const Logout = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      //   fill="#000000"
      fill="#007bff"
      className="mr-2"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
    </svg>
  );
};

export default Logout;

export {
  SportsCricketIcon,
  PolicyIcon,
  InfoIcon,
  LockIcon,
  AssignmentIcon,
  Spordia,
  HelpIcon,
  SettingsIcon,
  MailIcon,
  AnnouncementIcon,
  QuestionAnswerIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  MoreVertIcon,
  VisibilityOffIcon,
  VisibilityIcon,
  ArrowUpwardIcon,
  ArrowDownwardIcon,
  SearchIcon,
  FlashOnIcon,
  TuneIcon,
  ExploreIcon,
  LibraryBooksIcon,
  StarBorderIcon,
  StarIcon,
  LockOpenIcon,
  HomeIcon,
};
